{% block swag_cms_extensions_sidebar_section_scroll_behavior_config %}
    <div class="swag-cms-section-config__scroll-navigation">
        {% block swag_cms_extensions_sidebar_section_scroll_behavior_config_anchor_switch %}
            <mt-switch
                v-model="swagCmsExtensionsScrollNavigation.active"
                class="scroll-navigation__anchor-switch"
                :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.anchorSwitch')"
                :disabled="!acl.can('cms.editor')"
            />
        {% endblock %}

        {% block swag_cms_extensions_sidebar_section_scroll_behavior_config_anchor_title %}
            <mt-text-field
                v-model="swagCmsExtensionsScrollNavigation.displayName"
                class="scroll-navigation__anchor-title"
                :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.anchorTitle')"
                :helpText="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.anchorTitleHelpText')"
                :error="swagCmsExtensionsScrollNavigationDisplayNameError"
                :disabled="!acl.can('cms.editor')"
            />
        {% endblock %}
    </div>
{% endblock %}
